export default "__VITE_ASSET__I4zNSsUm__"